require('../../shared/highcharts-config')

const Perf_chart = require('../performances/perf-chart'),
  data = {
    name: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10'],
    perf: [0.95, 2.62, 3.91, 4.52, 7.42, 7.75, 8.65, 9.15, 10.76, 12.49],
    vol:  [1.57, 2.24, 3.06, 3.97, 4.56, 5.67, 6.38, 7.35, 7.94, 9.66]
  }

$(function() {
  Perf_chart(data)
})